import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "@client/store";
import { StatisticDesktopSkeletonPage } from "@common/components/Statistic/StatisticDesktopSkeletonPage";
import { useIsMobile } from "@common/hooks/isMobile";
import { CampaignReviewData } from "@common/api/__generated__";
import { StatisticTouchSkeletonPage } from "@common/components/Statistic/StatisticTouchSkeletonPage";
import { ShowCampaignTabStatisticTouch } from "@client/pages/ShowCampaign/Tabs/ShowCampaignTabStatisticTouch";
import { ShowCampaignTabStatisticDesktop } from "@client/pages/ShowCampaign/Tabs/ShowCampaignTabStatisticDesktop";

interface Props {
  campaign: CampaignReviewData;
}

export const ShowCampaignTabStatistic: React.FC<Props> = observer(
  ({ campaign }) => {
    const {
      campaignStatisticStore: { attach, isLoadingStatistic, detach },
    } = useStores();
    const isMobile = useIsMobile();

    useEffect(() => {
      attach(campaign.uuid);
      return detach;
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoadingStatistic) {
      if (isMobile) {
        return <StatisticTouchSkeletonPage />;
      }
      return <StatisticDesktopSkeletonPage />;
    }

    if (isMobile) {
      return <ShowCampaignTabStatisticTouch campaign={campaign} />;
    }
    return <ShowCampaignTabStatisticDesktop campaign={campaign} />;
  }
);
